<template>
    <Layout>
        <div class="view-plugin-form">
            <section class="fieldset">
                <PluginItem :infos="currentPlugin"></PluginItem>
                <FormBuilder :configuration="configuration"
                             :descriptor="descriptor"
                             @configurationChanged="setConfiguration"
                             @step="handleStep"
                             ref="formBuilder"
                             v-if="descriptor">
                </FormBuilder>
            </section>
        </div>
        <div slot="toolbarLeft">
            <Btn @click.native="previousStep" class="primary mobile-block pull-left" v-if="currentStep > 0">
              {{ $t('global.prev') }}
            </Btn>
        </div>
        <div slot="toolbar">
            <Btn @click.native="nextStep" class="primary mobile-block pull-right">
                <template v-if="isFinalStep">
                  {{ $t('global.activate') }}
                </template>
                <template v-else>
                  {{ $t('global.next') }}
                </template>
            </Btn>
        </div>
    </Layout>
</template>

<script>
    //import Component from 'path/to/component'

    import _filter from 'lodash/filter'

    import {mapGetters, mapMutations, mapActions} from 'vuex'

    import globalMixin from '@/mixins/global'

    import Layout from '@l/BaseWithToolbar'

    import FormBuilder from '@c/plugins/formbuilder/FormBuilder'
    import PluginItem from '@c/plugins/library/PluginItem'

    import transformers from '@s/transformers'

    import _find from 'lodash/find'

    import descriptor01 from '@a/json/descriptor01.json'
    import configuration01 from '@a/json/configuration01.json'

    export default {
        beforeCreate: function () {


        },
        beforeDestroy: function () {

        },
        beforeMount: function () {


        },
        beforeRouteLeave(to, from, next) {
            if(!this.finalized && to.name != 'Login'){
                window.App.$refs.confirm.show({
                    title: window.V.$i18n.t('plugins.titles.congigurationNotComplete'),
                    content: window.V.$i18n.t('plugins.titles.congigurationNotComplete'),
                    callbackYes: () => {
                        next()
                    },
                    callbackNo: () => {
                        this.$router.replace({name: from.name})
                    }
                });
            }
            else{
                next()
            }

        },
        beforeUpdate: function () {

        },
        components: {
            Layout,
            FormBuilder,
            PluginItem
        },
        computed: {
            ...mapGetters({
                currentPlugin: 'Plugins/current',
                currentStep: 'Plugins/currentStep'
            }),

            descriptor() {
                return this.currentPlugin.configDescriptor
            },

            configuration() {
                return this.currentPlugin.configuration
            },
            isFinalStep() {
                if (this.currentPlugin && this.currentPlugin.configDescriptor && this.currentStep == this.currentPlugin.configDescriptor.form.steps.length - 1) {
                    return true
                }
                return false
            }
        },
        created: function () {

        },
        data() {
            return {
                finalized: false
            }
        },
        destroyed: function () {

        },
        methods: {
            ...mapMutations({
                showLoading: 'UI/showLoading',
                setCurrentPlugin: 'Plugins/setCurrentPlugin',
                setCurrentPluginConfiguration: 'Plugins/setConfiguration',
                setCurrentStep: 'Plugins/setCurrentStep',
                setCurrentStepData: 'Plugins/setCurrentStepData',
                setConfigurationId: 'Plugins/setConfigurationId',
                setFinalStepMessage: 'Plugins/setFinalStepMessage'
            }),

            ...mapActions({
                fetchPluginDescription: 'Plugins/fetchPluginDescription',
                fetchPluginConfiguration: 'Plugins/fetchPluginConfiguration',
                createPlugin: 'Plugins/createPlugin',
                checkPluginStep: 'Plugins/checkPluginStep',
                beforePluginStep: 'Plugins/beforePluginStep',
                beforeFinalize: 'Plugins/beforeFinalize',
                finalizeConfiguration: 'Plugins/finalizeConfiguration',
            }),

            handleFilter() {

            },

            setConfiguration(newConfiguration) {
                this.setCurrentPluginConfiguration(newConfiguration)

            },

            getStepConfiguration() {
                let stepConfiguration = {}
                let descriptor = this.descriptor,
                    configuration = this.configuration,
                    step = this.currentStep

                let stepDescriptor = descriptor.form.steps[step].fields.map(item => {
                    if (item.token) {
                        return item.token
                    } else if (item.key) {
                        return item.key
                    }

                })


                stepConfiguration = Object.keys(configuration)
                    .filter(key => stepDescriptor.includes(key))
                    .reduce((obj, key) => {
                        if (typeof transformers[key] === 'function') {
                            obj[key] = transformers[key](configuration[key]);
                        } else {
                            obj[key] = configuration[key];
                        }

                        return obj;
                    }, {});


                return stepConfiguration
            },

            beforeStep() {

                if (this.currentPlugin.configDescriptor) {
                    if (this.currentPlugin.configDescriptor.form.steps[this.currentStep].before !== false) {
                        return this.beforePluginStep(this.currentPlugin.configurationId)
                            .then(response => {
                                let keys = Object.keys(response.data)
                                keys.forEach(key => {
                                    if (this.currentPlugin.configuration[key]) {
                                        this.currentPlugin.configuration[key] = response.data[key]
                                    }
                                })

                            })
                    } else if (this.currentStep == this.currentPlugin.configDescriptor.form.steps.length - 1) {
                        this.beforeFinalize(this.currentPlugin.configurationId)
                            .then(response => {
                                this.setFinalStepMessage(response.data.message)
                                //this.currentPlugin.configDescriptor.form.steps[this.currentPlugin.configDescriptor.form.steps.length - 1].fields[0].label.replace('{finalizeMessage}',response.data.message)

                            })
                    }
                }
                return null
            },

            nextStep() {
                this.showLoading(true)

                if (this.currentStep == this.currentPlugin.configDescriptor.form.steps.length - 1) {

                    this.finalizeConfiguration({id: this.currentPlugin.configurationId}).then(response => {
                        this.finalized = true
                        this.$router.replace({name: 'pluginsList'})
                    })
                } else if (this.$refs.formBuilder.$refs['step' + this.currentStep][0].validateStep()) {

                    if (this.currentPlugin.configDescriptor.form.steps[this.currentStep].after !== false) {
                        if (this.currentStep == 0 && this.$route.name == 'pluginNew') {
                            this.createPlugin({
                                pluginId: this.currentPlugin.pluginId,
                                configuration: this.getStepConfiguration()
                            })
                                .then(response => {
                                    this.setCurrentStep(this.currentStep + 1)
                                    this.setConfigurationId(response.data.message)
                                    this.beforeStep()
                                    document.getElementsByClassName('page-view')[0].scrollTop = 0
                                    this.showLoading(false)
                                })
                                .catch(error => {
                                    this.showLoading(false)
                                    if (error.response) {
                                        if (502 == error.response.status && 500 == error.response.status) {
                                            this.addError(error.response.data.message)
                                        }
                                        if (418 == error.response.status) {
                                            this.addError('Une erreur est survenue lors de l\'enregistrement de cette étape. Merci de vérifier les paramètres saisis.')
                                        }
                                    }

                                })
                        } else {
                            this.checkPluginStep({
                                configurationId: this.currentPlugin.configurationId,
                                configuration: this.getStepConfiguration()
                            }).then(response => {
                                this.setCurrentStep(this.currentStep + 1)

                                let hasExtra = _find(this.currentPlugin.configDescriptor.form.steps[this.currentStep].fields, item => {
                                    if (item.component && item.component.props && item.component.props.extra) {
                                        return true
                                    }
                                    return false
                                })

                                let promiseBefore = this.beforeStep()
                                document.getElementsByClassName('page-view')[0].scrollTop = 0
                                if (promiseBefore) {
                                    promiseBefore.then(response => {
                                        this.showLoading(false)
                                    })
                                } else {
                                    this.showLoading(false)
                                }

                            })
                                .catch(error => {
                                    this.showLoading(false)
                                    if (error.response) {
                                        if (502 == error.response.status && 500 == error.response.status) {
                                            this.addError(error.response.data.message)
                                        }
                                        if (418 == error.response.status) {
                                            this.addError('Une erreur est survenue lors de l\'enregistrement de cette étape. Merci de vérifier les paramètres saisis.')
                                        }
                                    }
                                })
                        }
                    }


                    //this.setCurrentStep(this.currentStep + 1)

                } else {
                    this.showLoading(false)
                }

            },

            previousStep() {
                this.showLoading(true)
                setTimeout(() => {
                    this.setCurrentStep(this.currentStep - 1)
                    this.beforeStep()
                    document.getElementsByClassName('page-view')[0].scrollTop = 0
                    this.showLoading(false)
                }, 500)


            },

            handleStep(index){
                this.showLoading(true)
                setTimeout(() => {
                    this.setCurrentStep(index)
                    this.beforeStep()
                    document.getElementsByClassName('page-view')[0].scrollTop = 0
                    this.showLoading(false)
                }, 500)
            }
        },
        mixins: [
            globalMixin
        ],
        mounted: function () {
            console.log('MOUNTED', this.showLoading)
            this.setCurrentStep(0)

            this.$store.commit('UI/backAction', 'historyBack')
            if (this.$route.name == "pluginEdit") {

                this.fetchPluginConfiguration(this.$route.params.id)
                    .then(response => {

                        this.$store.commit('UI/viewTitle', window.V.$i18n.t("plugins.pluginModify") +" "+ this.currentPlugin.name)

                        let promiseBefore = this.beforeStep()
                        if (promiseBefore) {
                            promiseBefore.then(response => {
                                this.showLoading(false)
                            })
                        } else {
                            this.showLoading(false)
                        }

                    })
            } else {
                this.$store.commit('UI/viewTitle', window.V.$i18n.t("plugins.pluginModify"))
                this.fetchPluginDescription(this.$route.params.id)
                    .then(response => {
                        this.showLoading(false);
                    })
            }


        },
        name: '',
        props: {},
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
    .view-plugin-form {
        padding: 20px;
        min-height: 100%;

        .fieldset {
            height: 100%;
            min-height: calc(100vh - 175px);
            display: flex;
            flex-direction: column;

            .plugin {
                box-shadow: none;
                padding: 0;
                cursor: default;
                margin-bottom: 20px;
                flex: 0 0 80px;
                transform: rotate(90deg) translate(0px, -75px);
                transform-origin: top left;
                position: fixed;
                width: 70vh;

                .logo-container img {
                    transform: rotate(-90deg);
                    transform-origin: center center;
                }

                .state {
                    flex: 0 0 0;
                }
            }

            .form-builder {
                flex: 1 1 100%;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/plugins/Form.vue